import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { CheckCircle2, Phone, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { SITE } from "@/data/site";
import { trackEvent, trackPhoneClick, trackMessengerClick } from "@/lib/analytics";

/** Страница «Спасибо» — URL для конверсий GA4 / Google Ads. */
function ThankYouPage() {
  useEffect(() => {
    trackEvent("generate_lead", {
      event_category: "conversion",
      event_label: "thank_you_page",
    });
  }, []);

  return (
    <div className="bg-background min-h-screen text-foreground flex flex-col">
      <Helmet>
        <title>Дякуємо за заявку | {SITE.domain}</title>
        <meta
          name="description"
          content="Заявку прийнято. Ми звʼяжемося з вами найближчим часом."
        />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-lg w-full text-center space-y-6">
          <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto" aria-hidden />
          <h1 className="text-3xl md:text-4xl font-bold text-balance">Дякуємо!</h1>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Заявку прийнято. Майстер звʼяжеться з вами найближчим часом, щоб підтвердити
            час і підібрати скло.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
            <Button size="lg" className="h-12" asChild>
              <a
                href={`tel:${SITE.phoneE164Primary}`}
                onClick={() => trackPhoneClick(SITE.phoneE164Primary)}
              >
                <Phone className="w-4 h-4 mr-2" />
                Подзвонити {SITE.phonePrimary}
              </a>
            </Button>
            <Button size="lg" variant="outline" className="h-12" asChild>
              <a
                href={SITE.telegram}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackMessengerClick("telegram")}
              >
                <Send className="w-4 h-4 mr-2" />
                Написати в Telegram
              </a>
            </Button>
          </div>

          <p className="pt-4">
            <Link to="/" className="text-primary hover:underline">
              Повернутися на головну
            </Link>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ThankYouPage;
